module.exports = __webpack_public_path__ + "img/event_stamp_bg.ade0670.jpg";